import { Component, OnInit } from '@angular/core';
import { Certificate, ArmaRestAnalysis as Order, DataSnapResultCertificats, DataSnapResult } from 'src/app/classes/json-interface';
import { CUtilit } from 'src/app/classes/utilit';
import { MatTableDataSource } from '@angular/material/table';
import { CST_CERTIFICATE_STYLE } from 'src/app/classes/const';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { HttpClient } from '@angular/common/http';
import { AppToolbarService } from '../toolbar/services/app-toolbar.service';

@Component({
  selector: 'app-tab-certificate',
  templateUrl: './tab-certificate.component.html',
  styleUrls: ['./tab-certificate.component.css']
})
export class TabCertificateComponent implements OnInit {

  HTML_currentCertificateStyle: number;
  HTML_CstStyle = CST_CERTIFICATE_STYLE;

  HTML_TableHeader = ['File name', 'Action'];            // En tête du tableau
  HTML_TableDataSource: MatTableDataSource<Certificate>; // Données du tableau

  HTML_arrayAnalysis: Order[];
  HTML_TableName: string = '';
  HTML_Search: string = '';
  HTML_showLoadingCircle: boolean;
  mDisableBTN: boolean = false;

  constructor(private http: HttpClient,
              private mToolbar: AppToolbarService) {
    this.HTML_currentCertificateStyle = -1;
    this.HTML_TableDataSource = new MatTableDataSource<Certificate>([]);
    this.HTML_arrayAnalysis = [];
    this.HTML_showLoadingCircle = false;
  }

  ngOnInit() {
  }

  public setComponentStyle(_CST_COMPONENT_STYLE: number) {
    this.clearTable();
    this.HTML_Search = '';
    this.HTML_currentCertificateStyle = _CST_COMPONENT_STYLE;
    if (this.HTML_currentCertificateStyle == CST_CERTIFICATE_STYLE.bySite) {
      this.HTML_TableName = 'Certificat par chantier';
      this.searchCertificateBySite();
    } else if (this.HTML_currentCertificateStyle == CST_CERTIFICATE_STYLE.byOrder) {
      this.HTML_TableName = 'Certificat par contrat';
      this.updateListOrder();
    } else if (this.HTML_currentCertificateStyle == CST_CERTIFICATE_STYLE.byDN) {
      this.HTML_TableName = 'Certificat par BL';
    } else if (this.HTML_currentCertificateStyle == CST_CERTIFICATE_STYLE.byTag) {
      this.HTML_TableName = 'Certificat par Etiq';
    }
  }

  public clearTable() {
    this.HTML_TableDataSource.data = [];
  }

  private async updateListOrder() {
    this.HTML_arrayAnalysis = (await (ArmaServConnection.aGET(this.http, 'GetListOrder', [this.mToolbar.selectedSiteCode]))).result[0];
  }

  public async searchCertificateBySite() {
    this.HTML_TableDataSource.data = [];
    this.HTML_showLoadingCircle = true;
    try {
      this.HTML_TableDataSource.data = (await ArmaServConnection.aGET(this.http, 'GetListCertBySite', [this.mToolbar.selectedSiteCode])).result[0];
    } finally {
      this.HTML_showLoadingCircle = false;
    }
  }

  public async searchCertificateByOrder(orderCode: string) {
    this.HTML_Search = orderCode;  // Pour le telechargement en zip (nom du fichier)
    this.HTML_TableDataSource.data = [];
    this.HTML_showLoadingCircle = true;
    try {
      this.HTML_TableDataSource.data = (await ArmaServConnection.aGET(this.http, 'GetListCertByOrder', [orderCode])).result[0];
    } finally {
      this.HTML_showLoadingCircle = false;
    }
  }

  public async searchCertificateByDN(DNCode: string) {
    this.HTML_TableDataSource.data = [];
    this.HTML_showLoadingCircle = true;
    try {
      this.HTML_TableDataSource.data = (await ArmaServConnection.aGET(this.http, 'GetListCertByDN', [DNCode])).result[0];
    } finally {
      this.HTML_showLoadingCircle = false;
    }
  }

  public async searchCertificateByTag(TagCode: string) {
    let temp = '';
    for (let i = 0 ; i < TagCode.length ; i++) {
      if (!isNaN(+TagCode[i]))
        temp += TagCode[i];
    }
    if (temp == '') temp = '0';
    TagCode = temp;
    this.HTML_TableDataSource.data = [];
    this.HTML_showLoadingCircle = true;
    try {
      this.HTML_TableDataSource.data =  (await ArmaServConnection.aGET(this.http, 'GetListCertByTag', [TagCode])).result[0];
    } finally {
      this.HTML_showLoadingCircle = false;
    }
  }

  public showCertificate(certificate: Certificate, download: boolean) {
    ArmaServConnection.getFile(this.http, certificate.DOC_PATH, certificate.DOC_NAME, download, !download);
  }

  public async downloadAllCertificats() {
    this.mDisableBTN = true;
    this.HTML_showLoadingCircle = true;
    try {
      const arrayFileName: string[] = []; // Tableau contenant seulement le chemin vers les fichier de certificats
      this.HTML_TableDataSource.data.forEach(certificate => arrayFileName.push(certificate.DOC_PATH)); // On remplis le tableau
      // On envois une requete pour preparer le zip afin de le telecharger par la suite
      const next: DataSnapResult = await ArmaServConnection.aPOST(this.http, 'CreateZip', arrayFileName, []);
      if (next && next.result[0]) {
        // On prepare le téléchargement en indicant le chemin du fichier ainsi que le type
        let fileName = 'Certificate ';
        switch (this.HTML_currentCertificateStyle) {
          case CST_CERTIFICATE_STYLE.byDN:
          case CST_CERTIFICATE_STYLE.byOrder:
          case CST_CERTIFICATE_STYLE.byTag:
            fileName += this.HTML_Search + '.zip';
            break;
          case CST_CERTIFICATE_STYLE.bySite:
            fileName += this.mToolbar.selectedSiteCode + '.zip';
            break;
        }
        ArmaServConnection.getFile(this.http, (next as DataSnapResult).result[0], fileName, true, false);
      } else throw next;
    } finally {
      this.mDisableBTN = false;
      this.HTML_showLoadingCircle = false;
    }
  }
}
